
import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import ApiUiController from '../../controller/ApiUiController';
import ReportAPI from '../../api/ReportAPI';
import withRouter from '../../util/WithRouter';
import ReportConst from '../../util/ReportConst';
import Const from '../../util/Constants';
import ReportSelect from './ReportSelect';
import ReportSelectToSelect from './ReportSelectToSelect';
import ReportSelectToTime from './ReportSelectToTime';
import ReportSelectToDay from './ReportSelectToDay';
import ReportSelectToMonth from './ReportSelectToMonth';
import ConsolidatedActivity from './ConsolidatedActivity';
import ReportComplexDownloadPreview from './ReportComplexDownloadPreview';
import ReportComplexSelectToSelect from './ReportComplexSelectToSelect';
import ReportComplexSelect from './ReportComplexSelect';
import ReportSelectToHr from './ReportSelectToHr';
import ReportComplexTimeToSelect from './ReportComplexTimeToSelect';
import ReportTime3D from './ReportTime3D';
import ReportTarget from './ReportTarget';
import Util from '../../util/Util';

class ReportPreview extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.id = parseInt(props.match.params.reportId);
    this.state = { inApiCall: true };
    this.filters = null;
  }

  componentDidMount() { ReportAPI.get(this.id, this.onReport, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReport = res => {
    this.report = res;
    this.setState({ ...this.state, inApiCall: false });
  };

  saveFilter = filters => reactLocalStorage.setObject(Const.ReportFilter + this.id, filters);

  render() {
    let report = <div></div>;
    if (this.report && this.report.type === ReportConst.Select) {
      report = <ReportSelect report={this.report} prevFilters={this.filters} saveFilter={this.saveFilter} />;
    } else if (this.report && this.report.type === ReportConst.SelectToSelect) {
      report = <ReportSelectToSelect report={this.report} prevFilters={this.filters} saveFilter={this.saveFilter} />;
    } else if (this.report && (this.report.type === ReportConst.SelectToHr
      || this.state.type === ReportConst.SelectToHrDuplicate)) {
      report = <ReportSelectToHr report={this.report} prevFilters={this.filters}
        saveFilter={this.saveFilter} />;
    } else if (this.report && this.report.type === ReportConst.SelectToDay) {
      report = <ReportSelectToDay report={this.report} prevFilters={this.filters} saveFilter={this.saveFilter} />;
    } else if (this.report && this.report.type === ReportConst.SelectToTime) {
      report = <ReportSelectToTime report={this.report} prevFilters={this.filters} saveFilter={this.saveFilter} />;
    } else if (this.report && this.report.type === ReportConst.SelectToMonth) {
      report = <ReportSelectToMonth report={this.report} prevFilters={this.filters} saveFilter={this.saveFilter} />;
    } else if (this.report && this.report.type === ReportConst.Consolidate
      && this.report.model === ReportConst.ConsolidatedActivity) {
      report = <ConsolidatedActivity report={this.report} />;
    } else if (this.report && this.report.type === ReportConst.Target) {
      report = <ReportTarget report={this.report} />;
    } else if (this.report && this.report.type === ReportConst.Time3D) {
      report = <ReportTime3D report={this.report} prevFilters={this.filters} saveFilter={this.saveFilter} />;
    } else if (this.report && this.report.view_type === ReportConst.Download) {
      report = <ReportComplexDownloadPreview
        report={this.report}
        prevFilters={this.filters}
        saveFilter={this.saveFilter} />;
    } else if (this.report && this.report.type === ReportConst.ComplexSelect) {
      report = <ReportComplexSelect report={this.report} prevFilters={this.filters} saveFilter={this.saveFilter} />;
    } else if (this.report && this.report.type === ReportConst.ComplexSelectToSelect) {
      report = <ReportComplexSelectToSelect report={this.report} prevFilters={this.filters} saveFilter={this.saveFilter} />;
    } else if (this.report && this.report.type === ReportConst.ComplexTimeToSelect) {
      report = <ReportComplexTimeToSelect report={this.report} prevFilters={this.filters} saveFilter={this.saveFilter} />;
    }
    return (<ApiUiController inApiCall={this.state.inApiCall}>{report}</ApiUiController>);
  }
}
export default withRouter(ReportPreview);